import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./assets/css/tailwind.output.css";
import "./assets/css/font-awesome.min.css";
import App from "./App";
import { SidebarProvider } from "./context/SidebarContext";
import { SnackbarProvider } from "./context/SnackbarContext";
import { AuthProvider } from "./context/AuthContext";
import ThemedSuspense from "./components/ThemedSuspense";
import StepContext from "../src/context/MultiStepFormContext";
import "../src/translations/i18n";
import { QueryClient, QueryClientProvider } from "react-query";
import "whatwg-fetch";
import { ThemeProvider } from "./context/ThemeContext";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 5,
        },
    },
});
const container = document.getElementById("root");
const root = createRoot(container);
root.render(_jsx(QueryClientProvider, { client: queryClient, children: _jsx(SidebarProvider, { children: _jsx(SnackbarProvider, { children: _jsx(AuthProvider, { children: _jsx(Suspense, { fallback: _jsx(ThemedSuspense, {}), children: _jsx(StepContext, { children: _jsx(ThemeProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }));
